import { css } from '@emotion/core';
import vars from '../../current-theme-variables';
export var insetBlock = /*#__PURE__*/css("width:100%;max-width:", vars.global.pageBodyWidth, ";margin:0 auto;");
export var contentBlock = {
  name: "1pmyvs2",
  styles: "padding:40px 0;"
};